<div class="camera">
  <mat-form-field>
    <mat-label>Aparat</mat-label>
    <input matInput type="text" [(ngModel)]="address" />
  </mat-form-field>
  <lib-button lg (click)="connect()">Połącz</lib-button>
</div>
<div class="options">
  <div class="schools">
    @for (school of schools; track school) {
      <div
        class="school"
        [ngClass]="{ active: school[0] === currentSchool }"
        (click)="setSchool(school[0])"
        >
        {{ school[1] }}
      </div>
    }
  </div>

  <div class="schools">
    @for (school of classes; track school) {
      <div
        class="school"
        [ngClass]="{ active: school[0] === currentClass }"
        (click)="setClass(school[0])"
        >
        {{ school[1] }}
      </div>
    }
  </div>
  <ng-container [formGroup]="form">
    <div class="schools" formArrayName="children">
      @for (school of children; track school; let i = $index) {
        <div class="school">
          <lib-checkbox [formControl]="childrenForm.at(i)">{{
            school[1]
          }}</lib-checkbox>
        </div>
      }
    </div>
  </ng-container>

  <div class="schools">
    @for (school of products; track school) {
      <div
        class="school"
        [ngClass]="{ active: school[0] === currentProduct }"
        (click)="setProduct(school[0])"
        >
        {{ school[1] }}
      </div>
    }
  </div>
</div>
